import { useState } from "react";
import React from "react";
import { Link } from "react-router-dom";
import ChangePasswordForm from "../PasswordChange";
import PersonalData from "../popups/PersonalData";
import CoWorkers from "../popups/CoWorkers";
import Editing from "../popups/Editing";
import OurCompany from "../popups/OurCompany";

import logo from "../../assets/images/logo.jpg";
import close from "../../assets/svg/free-icon-minimize-sign-6057365 2.svg";
import minimize from "../../assets/svg/icon-minimize-sign.svg";
import rollUp from "../../assets/svg/icon_roll up.svg";
import home from "../../assets/svg/icon-home.svg";

const NavGeneral = () => {
  const [isShownPasswordForm, setIsShownPasswordForm] = useState(false);
  const [isShownDataForm, setIsShownDataForm] = useState(false);
  const [isShownCoWorkersForm, setIsShownCoWorkersForm] = useState(false);
  const [isShownCompanyForm, setIsShownCompanyForm] = useState(false);
  const [isShownEditingForm, setIsShownEditingForm] = useState(false);
  const changeIsDataFormOpen = () => {
    setIsShownDataForm(!isShownDataForm);
  };
  const changePassword = () => {
    setIsShownPasswordForm(!isShownPasswordForm);
  };
  const changeIsCoWorkersOpen = () => {
    setIsShownCoWorkersForm(!isShownCoWorkersForm);
  };
  const changeIsOurCompanyOpen = () => {
    setIsShownCompanyForm(!isShownCompanyForm);
  };
  const changeIsEditingForm = () => {
    setIsShownEditingForm(!isShownEditingForm);
  };

  return (
    <nav className="navbar generalNav">
      {isShownPasswordForm && (
        <ChangePasswordForm changePassword={changePassword} />
      )}
      {isShownPasswordForm && (
        <ChangePasswordForm changePassword={changePassword} />
      )}
      {isShownDataForm && (
        <PersonalData changeIsDataFormOpen={changeIsDataFormOpen} />
      )}
      {isShownCoWorkersForm && (
        <CoWorkers changeIsCoWorkersOpen={changeIsCoWorkersOpen} />
      )}
      {isShownCompanyForm && (
        <OurCompany changeIsOurCompanyOpen={changeIsOurCompanyOpen} />
      )}
      {isShownEditingForm && (
        <Editing changeIsEditingForm={changeIsEditingForm} />
      )}
      <div className="upperNav">
        <div className="upperNav-left">
          <Link to={"/clasificator"} className="upperNav-btn">
            Меню
          </Link>
          <button className="upperNav-btn" onClick={changeIsEditingForm}>
            Общее
          </button>
          <button className="upperNav-btn" onClick={changeIsOurCompanyOpen}>
            Действия
          </button>
          <button className="upperNav-btn" onClick={changeIsCoWorkersOpen}>
            Служебное
          </button>
        </div>
        <div className="upperNav-right">
          <Link to="#" className="upperNav-right__link">
            Наши расчетные счета
          </Link>
          <div className="upperNav-right__menu">
            <button className="upperNav-right__icon">
              <img src={minimize} alt="Minimize" />
            </button>
            <button className="upperNav-right__icon">
              <img src={rollUp} alt="Roll up" />
            </button>
            <button className="upperNav-right__icon">
              <img src={close} alt="Close" />
            </button>
          </div>
        </div>
      </div>

      <div className="middleNav">
        <div className="middleNav-left">
          <div className="middleNav-left1">
            <button className="middleNav-link" onClick={changePassword}>
              <img src={home} alt={"HomeIcon"} className="middleNav-icon" />
            </button>
            {/* ---- */}
            <div className="middleNav-middle">
              <div className="middleNav-middle__1">
                <button className="middleNav-middle__btn">Выполнить...</button>
                <p>...</p>
                <p className="middleNav-middle__p">Добавить категорию</p>
              </div>

              <div className="middleNav-middle__2">
                <div className="middleNav-middle__part">
                  <Link to={"/"}>История изменнеий</Link>
                  <Link to={"/"}>Коды внешней интеграции</Link>
                  <Link to={"/"}>Копировать в буфет</Link>
                </div>
                <div className="middleNav-middle__part">
                  <Link to={"/"}>Остатки по товару / детализация</Link>
                  <Link to={"/"}>Правила характеристик</Link>
                  <Link to={"/"}>Разное...</Link>
                </div>
                <div className="middleNav-middle__part">
                  <Link to={"/"}>Редактирование списка</Link>
                  <Link to={"/"}>Сделать снимок данных</Link>
                  <Link to={"/"}>Слияние</Link>
                </div>
                <div className="middleNav-middle__part">
                  <Link to={"/"}>Снимки данных</Link>
                  <Link to={"/"}>Сохранить файл(ы)</Link>
                  <Link to={"/"}>Характеристики</Link>
                </div>
              </div>
              {/* ---- */}
            </div>
          </div>
        </div>
        <div className="middleNav-right">
          <p className="middleNav-right__lang">РУС</p>
          <Link to={"/"}>
            <img src={logo} alt="Logo" className="middleNav-right__logo" />
          </Link>
        </div>
      </div>
      <div className="lowerNav">
        <div className="upperNav-left">
          <Link to={"/"} className="upperNav-btn">
            Классификатор
          </Link>
          <Link to={"/"} className="upperNav-btn">
            Карточка
          </Link>
          <Link to={"/"} className="upperNav-btn">
            Закладки
          </Link>
          <Link to={"/"} className="upperNav-btn">
            Поиск
          </Link>
        </div>
        <div className="upperNav-right">
          <div className="upperNav-right__menu">
            <button className="upperNav-right__icon">
              <img src={minimize} alt="Minimize" />
            </button>
            <button className="upperNav-right__icon">
              <img src={rollUp} alt="Roll up" />
            </button>
            <button className="upperNav-right__icon">
              <img src={close} alt="Close" />
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavGeneral;
